import FlavourBanVideo from './FlavourBanVideo';

export default FlavourBanVideo;
